




import { Component, Vue, Prop } from 'vue-property-decorator'
import { RoomStorage } from '@/class/roomStorage'
import Textarea from '@/components/Utils/form/textarea/Textarea.vue'

@Component({
  components: {
    Textarea
  }
})
export default class Memo extends Vue {
  // ここの実装めちゃくちゃ気に食わないけど一旦はこれで...
  @Prop() gameId!: string;
  @Prop() playerId!: string;
  roomStrage = new RoomStorage(this.$route.params.roomId);

  memo = ""

  created () {
    const memoOf = this.roomStrage.gameDataOf[this.gameId]?.memoOf || {}
    this.memo = memoOf[this.playerId]
  }

  saveMemo (memo: string) {
    this.roomStrage.saveMemo(this.gameId, this.playerId, memo)
  }
}
